import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

const echo = new Echo({
    broadcaster: 'reverb',
    key: import.meta.env.VITE_REVERB_APP_KEY,
    wsHost: import.meta.env.VITE_REVERB_HOST,
    wsPort: import.meta.env.VITE_REVERB_PORT ?? 80,
    wssPort: import.meta.env.VITE_REVERB_PORT ?? 443,
    forceTLS: (import.meta.env.VITE_REVERB_SCHEME ?? 'https') === 'https',
    enabledTransports: ['ws', 'wss'],
    authEndpoint: `${import.meta.env.VITE_API_URL || 'http://localhost:8000'}/api/broadcasting/auth`,
    auth: {
        headers: {
            get Authorization() {
                return `Bearer ${localStorage.getItem('auth_token')}`;
            },
        },
    },
});

// Debugging for WebSocket connection issues
echo.connector.pusher.connection.bind('error', (err) => {
    console.error('WebSocket Connection Error:', err);
});

echo.connector.pusher.connection.bind('state_change', (states) => {
    console.log('WebSocket State:', states.current);
});

export default echo;
